import { ValueOf } from './util';

/** 口座科目のenum */
export const EBankAccountType = {
  DEPOSIT_ACCOUNT: '普通',
  CHECKING_ACCOUNT: '当座',
  SAVING_ACCOUNT: '貯蓄',
} as const;

export type BankAccountTypeKey = keyof typeof EBankAccountType;
export type BankAccountTypeValue = ValueOf<typeof EBankAccountType>;

export const bankAccountTypeKeys = Object.keys(EBankAccountType) as (BankAccountTypeKey[]);

/** v-select用items */
export const bankAccountTypeItems = bankAccountTypeKeys
  .map((key) => ({
    title: EBankAccountType[key],
    value: key,
  }));
